<template>
  <button class="vue-calc-btn" :disabled="_disabled" @click="submitOption">
    {{ nextStepLabel ? nextStepLabel : "Passer à l'étape suivante" }}
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    selectedOption: {
      default: null
    },
    gtm: {
      required: true
    }
  },
  data: () => ({
    temporaryDisabled: false
  }),
  computed: {
    nextStepLabel() {
      return this.$store.getters.nextStepLabel;
    },
    _disabled() {
      return (
        this.temporaryDisabled ||
        this.selectedOption == null ||
        (Array.isArray(this.selectedOption) &&
          this.selectedOption.length === 0) ||
        this.disabled
      );
    }
  },
  methods: {
    submitOption() {
      this.$pushGTM(this.gtm);

      // Submit option
      this.$store.dispatch("submitOption", this.selectedOption);
      this.temporaryDisable();
    },
    temporaryDisable() {
      this.temporaryDisabled = true;
      setTimeout(() => {
        this.temporaryDisabled = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.vue-calc-btn {
  align-self: center;
  position: relative;
  background: $c-primary;
  color: $c-primary-contrast;
  padding: 14px 55px 14px 20px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  box-shadow: 0 0 0 5px lighten($c-primary, 5%);
  transition: all $s-transition;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 11px;
    display: block;
    mask: url("~@/assets/images/back-button-icon.svg") no-repeat center/contain;
    width: 28px;
    height: 28px;
    background: currentColor;
    transform: scaleX(-1) translateY(-50%);

    @include ie-only {
      mask: none;
      background: url("~@/assets/images/back-button-icon.svg") no-repeat
        center/contain;
    }
  }

  &:active,
  &:focus {
    outline: none;
  }

  &:hover {
    box-shadow: 0 0 0 5px darken($c-primary, 5%);
  }

  &:disabled {
    cursor: default;
  }

  .eficiensCalculatorApp--media & {
    font-size: 21px;
  }
}
</style>
